import React from 'react';
import { Cell, List, ListDataRefresher, useShowContextRequired } from 'ui-builder';
import { TASKS_GROUPS_ADMIN_UPDATED, TasksGroup, useTasksGroupsAdminService } from 'nekst-api';
import { GridLayout, TasksGroupIcon } from 'features/nekst-widgets';
import InnerBlock from '../../../shared/web/layout/InnerBlock';
import { CreateTasksGroupAdminButton } from './CreateTasksGroupAdminForm';
import { UpdateTasksGroupAdminButton } from './UpdateTasksGroupAdminForm';
import { DeleteTasksGroupAdminButton } from './DeleteTasksGroupAdminButton';
import { SettingsBreadcrumbs } from '../../settingsModule';
import { Breadcrumb } from '../../../shared/web/layout/Breadcrumbs';

function NameField() {
  const showContext = useShowContextRequired<TasksGroup>();

  return (
    <TasksGroupIcon
      group={showContext.data}
      withName
    />
  );
}

export default function TasksGroupsAdminList() {
  const tasksGroupsAdminService = useTasksGroupsAdminService();

  return (
    <InnerBlock
      title="Tasks Groups Administration"
      headerRight={<CreateTasksGroupAdminButton />}
    >
      <SettingsBreadcrumbs>
        <Breadcrumb text="Tasks Groups Administration" />
      </SettingsBreadcrumbs>
      <List getDataFunc={tasksGroupsAdminService.getTasksGroups}>
        <GridLayout weights={[10, 2]}>
          <Cell label="Group Name">
            <NameField />
          </Cell>
          <Cell label="Actions">
            <UpdateTasksGroupAdminButton />
            <DeleteTasksGroupAdminButton />
          </Cell>
        </GridLayout>
        <ListDataRefresher eventName={TASKS_GROUPS_ADMIN_UPDATED} />
      </List>
    </InnerBlock>
  );
}
